import { useTranslation } from "@/core/i18n";

export const PersonalisationAIAdvisorAvatar = ({
  avatarUrl,
  name,
}: {
  avatarUrl: string;
  name: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex h-8 w-8 items-center gap-3 rounded-full bg-[#DEC19C]">
      <img
        src={avatarUrl}
        alt={t("personalisationAIAdvisorAvatar.avatarAlt", { name })}
        className="h-8 w-8 rounded-full object-cover"
      />
    </div>
  );
};
